import React, { useEffect, useState } from 'react';
import noop from 'lodash/noop';
import { HeaderActions } from '@/finsight/ui/components/deals/DealListTable/components/HeaderActions';
import { useDealContext } from '@/finsight/application/Deal/DealContext';
import { ProfileTypes } from '@/finsight/application/actions/profile/constants';

import styles from '@/finsight/ui/components/deals/DealListTable/components/DealHeader/dealHeader.scss';

export interface IDealsHeaderProps {
  title?: React.ReactNode,
  titleToolbar?: React.ReactNode,
  innerRef?: (el: HTMLElement) => void,
  profileType?: ProfileTypes,
  showDealStatusFilters?: boolean,
  children?: React.ReactNode,
}

export const DealHeader = ({
  title = 'Recent New Issue',
  innerRef = noop,
  profileType,
  titleToolbar,
  showDealStatusFilters = true,
  children,
}: IDealsHeaderProps) => {
  const { isFetching } = useDealContext();
  const [firstFetchIsDone, setFirstFetchIsDone] = useState<boolean>(true);

  useEffect(() => {
    if (isFetching && !firstFetchIsDone) {
      setFirstFetchIsDone(true);
    }
  }, [isFetching]);

  return (
    <div
      ref={ innerRef }
    >
      { (title || (!firstFetchIsDone && isFetching)) && (
        <div className={ styles.header }>
          <div className={ styles.headerInner }>
            { title && <h3 className={ styles.title }>{ title }</h3> }
            { titleToolbar }
          </div>
          <HeaderActions
            showDealStatusFilters={ showDealStatusFilters }
            profileType={ profileType }
          />
        </div>
      ) }

      { children }
    </div>
  );
};
